/* eslint-disable global-require */

'use-strict';

/* @ngInject */
export default function routing($routeProvider) {
  $routeProvider
    .when('/workflows/add', {
      templateUrl: require('./workflow-rule-form/rule-form.template.html'),
      title: 'Neuer Workflow',
    })
    .when('/workflows/edit/:ruleId', {
      templateUrl: require('./workflow-rule-form/rule-form.template.html'),
      title: 'Workflow bearbeiten',
    })
    .when('/workflows/table', {
      templateUrl: require('./workflow-table/workflow-table.template.html'),
      title: 'Alle Workflows',
    })
    .when('/workflows/events', {
      templateUrl: require('./workflow-events/events.template.html'),
      title: 'Workflow Protokoll',
    })

    // TASKS
    .when('/tasks/table', {
      templateUrl: require('./task-table/task-table.template.html'),
      title: 'Offene Aufgaben',
    })
    .when('/tasks/task/:taskId', {
      templateUrl: require('./task/task.template.html'),
      title: 'Aufgabe',
    })
    .when('/tasks/new-task', {
      templateUrl: require('./task-form/task-form.template.html'),
      title: 'Neue Aufgabe erstellen',
    });
}
